module.exports = __webpack_public_path__ + "img/map.98eb2e1f.jpg";